import { getSelectedField, getSelectedInput } from './getSelectedField';
/**
 * Every search field a widget's aggregations refer to, including breakdowns and the
 * fields a top hits aggregation orders by.
 */
export function getAggregationFields(aggregations) {
    return (aggregations || []).flatMap((aggregation) => {
        var _a;
        const field = getSelectedField(aggregation);
        const [orderBy] = ((_a = aggregation === null || aggregation === void 0 ? void 0 : aggregation.topHitsInput) === null || _a === void 0 ? void 0 : _a.orderBy) || [];
        const orderByFields = Object.keys(orderBy || {});
        const input = getSelectedInput(aggregation);
        return [...(field ? [field] : []), ...orderByFields, ...getAggregationFields(input === null || input === void 0 ? void 0 : input.aggregations)];
    });
}
